/**
 * @file Case Study Video Modal
 */

import Player from '@vimeo/player';

/**
 * Case Study Video Modal component.
 */
const vVideoModal = () => {
	const videoModals = document.querySelectorAll('.a-cs-video-modal');

	if (!videoModals.length) {
		return;
	}

	const body = document.querySelector('body');
	const videoOverlay = document.querySelector('.video-overlay');
	const videoSizer = videoOverlay.querySelector('.video-overlay__sizer rect');
	const videoWrap = videoOverlay.querySelector('.video-overlay__wrap');
	const video = videoOverlay.querySelector('.video-overlay__video');
	const videoContent = videoOverlay.querySelector('.video-overlay__content');

	let player;

	[...videoModals].forEach((modal) => {
		const trigger = modal.querySelector('.a-cs-video-modal__trigger');
		trigger.addEventListener('click', () => {
			player = new Player(video, {
				url: trigger.dataset.url
			});

			player.on('loaded', () => {
				videoContent.classList.add('video-loaded');
				player.play();
			});

			player.setColor('#31c3e4').then(function(color) {
			}).catch(function(error) {
			});

			// window.vToggleOverlay('open', 'cs-video');
			document.dispatchEvent(new CustomEvent('vToggleOverlay', {
				detail: {
					state: 'open',
					name: 'cs-video',
				},
			}));
			const width = videoSizer.getBoundingClientRect().width;
			videoWrap.style.width = `${width}px`;
		});
	});

	// window.onOverlayStateChange.push(() => {
	// 	if (!player) return;
	// 	if (!window.overlayIsOpen && typeof player.destroy === 'function') {
	// 		player.destroy();
	// 		videoContent.classList.remove('video-loaded');
	// 	}
	// });

	document.addEventListener('vOverlayTransitioning', ({detail}) => {
		if (!player) {
			return;
		}

		const {name} = detail;

		if (name !== 'cs-overlay' && typeof player.destroy === 'function') {
			player.destroy();
			videoContent.classList.remove('video-loaded');
		}
	});

	// document.addEventListener('swup:contentReplaced', () => {
	// 	if (player && typeof player.destroy === 'function') {
	// 		player.destroy();
	// 	}
	// })
};

export default vVideoModal;
